<template>
    <div class="wg-toggle">
        <button
            class="wtb"
            :class="{ a: value === 'list' }"
            type="button"
            @click="setView('list')"
        >
            <v-icon size="14">mdi-format-list-bulleted</v-icon>
        </button>
        <button
            class="wtb"
            :class="{ a: value === 'cards' }"
            type="button"
            @click="setView('cards')"
        >
            <v-icon size="14">mdi-view-module</v-icon>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ChangeViewBtn',
    props: {
        value: {
            type: String,
            default: 'cards',
        },
        cacheKey: {
            type: String,
            default: null,
        },
    },
    computed: {
        inputVal: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    methods: {
        setView(view) {
            if (this.cacheKey) {
                localStorage.setItem(this.cacheKey, view)
            }
            this.inputVal = view
        },
    },
    created() {
        if (this.cacheKey) {
            const cachedValue = localStorage.getItem(this.cacheKey)
            if (cachedValue) {
                this.setView(cachedValue)
            }
        }
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.wg-toggle
    display: flex
    gap: 4px

.wtb
    width: 28px
    height: 28px
    border-radius: 5px
    border: 1px solid $border-new
    background: #fff
    cursor: pointer
    display: flex
    align-items: center
    justify-content: center
    padding: 0
    color: $muted-new
    transition: border-color .15s ease, background-color .15s ease, color .15s ease

    &:hover:not(.a)
        border-color: $border-hover-new

    &:focus-visible
        outline: 2px solid rgba($main-new, .35)
        outline-offset: 1px

    &.a
        border-color: $border-hover-new
        background: rgba($main-new, .08)
        color: $main-new

    ::v-deep .v-icon
        color: inherit !important
</style>
